// Generated by ts-to-zod
import { z } from 'zod';

export const canAccessInsightsResponseSchema = z.object({
  canAccessInsights: z.boolean(),
});
